import { onBeforeUnmount, onMounted, ref, type Ref } from "vue";

export function useIdleCursor(idleMs = 2000): { cursorValue: Ref<string> } {
    const cursorValue = ref("none");
    let debounce: ReturnType<typeof setTimeout> | null = null;

    const showCursor = () => {
        if (debounce != null) clearTimeout(debounce);
        cursorValue.value = "auto";
        debounce = setTimeout(() => {
            cursorValue.value = "none";
        }, idleMs);
    };

    onMounted(() => {
        window.addEventListener("mousemove", showCursor);
        window.addEventListener("mousedown", showCursor);
    });

    onBeforeUnmount(() => {
        window.removeEventListener("mousemove", showCursor);
        window.removeEventListener("mousedown", showCursor);
        if (debounce != null) clearTimeout(debounce);
    });

    return { cursorValue };
}
